<div class="hero">
  <div class="container mb-2">
    <div class="row pt-1 pb-1 d-none d-lg-flex hero-image">
      <div class="col-sm-6">
        &nbsp;
      </div>
      <div class="col-sm-6 mt-4">
        <div class="main-text ms-4 mt-5">
          Saving on dentistry
          is serious business.
        </div>
        <div class="sub-text ms-sm-4 mt-1">
          So is your oral health. That’s why we enjoy making it more affordable with Smile Generation Dental Plan<span class="tr">®</span>.
        </div>
        <div class="sub-text ms-lg-4 mt-4">
          <div class="btn btn-lg" style="width: 275px;font-size: 16px;" routerLink="/purchase">Start saving</div>
        </div>
      </div>
    </div>
    <div class="row d-lg-none">
      <div class="col-12 hero-image-sm">
      </div>
      <div class="header-text-bold text-start mb-4">
        Saving on dentistry
        is serious business.
      </div>
      <div class="hero-info-text">A discount dental plan designed to help you save and stay healthy</div>
      <div class="sub-text mt-4 mb-4 d-sm-block d-flex justify-content-center">
        <div class="btn btn-lg" style="width: 275px;" routerLink="/purchase">Start saving</div>
      </div>
    </div>
  </div>
</div>
